import { StyledContent, StyledTitle } from '@/components/styles'
import { ContentSection, Articles } from '@/components'
import { useTranslation } from "react-i18next";

export default function PromotionsPage(props) {
  const { currentPromotions = [], pastPromotions = [] } = props
  const { t } = useTranslation("global");

  return (
    <StyledContent withLine>
      <StyledContent.Container>
        <StyledContent.Columns>
          <div>
            <StyledContent.Side>
              <StyledTitle mb="medium" as="h1">
              {t('promotions.titlePage')}
              </StyledTitle>
            </StyledContent.Side>
          </div>
          <StyledContent.ColumnMain>
            {currentPromotions.length > 0 || pastPromotions.length > 0 ? (
              <>
                {currentPromotions.length > 0 && (
                  <ContentSection title={t('promotions.titleCurrent')}>
                    <Articles data={currentPromotions} articleType="promotion" />
                  </ContentSection>
                )}
                {pastPromotions.length > 0 && (
                  <ContentSection title={t('promotions.titlePast')}>
                    <Articles data={pastPromotions} articleType="promotion" />
                  </ContentSection>
                )}
              </>
            ) : (
              <StyledContent.Empty>{t('promotions.empty')}</StyledContent.Empty>
            )}
          </StyledContent.ColumnMain>
        </StyledContent.Columns>
      </StyledContent.Container>
    </StyledContent>
  )
}
